t = require('views/internal/teacup-with-helpers')('create_first_board')

module.exports = t.renderable ({ madLibsNoSkip }) ->
  if !madLibsNoSkip
    t.a '.first-board-skip.js-cancel', { href: "#" }, ->
      t.format 'skip-this'

  # mock board
  t.div '.first-board-column.first-board-image.board-name-background', ->
    t.div '.first-board-image-wrapper', ->
      t.div '.first-board-image-base', ->
        t.div '.board-name-display', ->
          t.p '.js-board-name-display'
        t.div '.first-board-image-list-container', ->
          t.div '.first-board-image-list.list-name-display', ->
            t.p '.js-list-name-display'
            t.div '.first-board-image-card.card-name-display', ->
              t.p '.js-card-name-display'
            t.div '.first-board-image-card.card-name-display', ->
              t.p '.js-card-name-display'
            t.div '.first-board-image-card.card-name-display', ->
              t.p '.js-card-name-display'
          t.div '.first-board-image-list.list-name-display', ->
            t.p '.js-list-name-display'
            t.div '.first-board-image-card.large'
            t.div '.first-board-image-card'
            t.div '.first-board-image-card.large'
          t.div '.first-board-image-list.list-name-display', ->
            t.p '.js-list-name-display'
            t.div '.first-board-image-card'
            t.div '.first-board-image-card.large'
            t.div '.first-board-image-card'
      t.div '.first-board-image-base-shadow.hide'
      t.img { src: require('images/first-board-low-fidelity-card-back.svg'), class: 'check-name-image hide' }
      t.div '.check-name-display', ->
        t.p '.js-check-title-display'
        t.p '.check-name-placeholder.hide', ->
          t.format 'add-an-item'
        t.p '.js-check-name-display'

  # prompts
  t.div '.first-board-column.first-board-content-wrapper', ->
    t.div '.first-board-content', ->
      # navigation
      t.div '.first-board-navigation', ->
        t.span '.js-step.current-step', { 'data-step': 'board-name' }
        t.span '.js-step', { 'data-step': 'list-name' }
        t.span '.js-step', { 'data-step': 'card-name' }
        t.span '.js-step', { 'data-step': 'check-name' }
      t.div '.first-board-text-wrapper', ->
        t.div '.first-board-text.js-step-text', ->
          # step 1: name board
          t.div '.board-name', ->
            t.h2 ->
              t.format 'welcome-to-trello'
            t.p ->
              t.format 'you-can-organize-just-about-anything-with-a-trello-board'
              t.span '.show-point-right', ->
                t.format 'that-thing-over-there'
              t.span '.show-point-up', ->
                t.format 'that-thing-up-there'
            t.p ->
              t.format 'start-by-naming-your-board-something-related-to-the-project'
            t.input '.js-board-name', { placeholder: t.l('eg-vacation-planning'), maxlength: "32" }

          # step 2: name lists
          t.div '.list-name.hide', ->
            t.h2 ->
              t.format 'create-structure-with-lists'
            t.p ->
              t.format 'a-list-is-a-collection-of-cards'
            t.p ->
              t.format 'a-lot-of-people-like-to-start-with'
            t.input '.js-list-name', { value: t.l('things-to-do'), maxlength: "16" }
            t.input '.js-list-name', { value: t.l('doing'), maxlength: "16" }
            t.div '.third-input', ->
              t.span ->
                t.format 'and'
              t.input '.js-list-name', { value: t.l('done'), maxlength: "16" }
            t.p '.post-input', ->
              t.format 'go-ahead-and-rename-your-lists-if-youd-like'

          # step 3: add card titles
          t.div '.card-name.hide', ->
            t.h2 ->
              t.format 'take-a-load-off-with-cards'
            t.p ->
              t.format 'make-cards-for-things'
            t.p ->
              t.span '.js-text-with-list-name'
            t.input '.js-card-name', { placeholder: t.l('eg-book-flights'), maxlength: "32" }
            t.input '.js-card-name', { placeholder: t.l('eg-find-a-hotel'), maxlength: "32" }
            t.div '.third-input', ->
              t.span ->
                t.format 'and'
              t.input '.js-card-name', { placeholder: t.l('eg-call-dogsitter'), maxlength: "32" }

          # step 4: create checklist item
          t.div '.check-name.hide', ->
            t.h2 ->
              t.format 'get-into-the-details'
            t.p ->
              t.format 'when-you-click-on-a-card-you-can-add-just-about-any-kind-of-info'
            t.p ->
              t.span '.js-text-with-card-name'
            t.div '.checklist-item', ->
              t.div '.checklist-box'
              t.input '.js-check-name', { placeholder: t.l('eg-do-something'), maxlength: "28" }

    t.div '.first-board-footer-wrapper', ->
      t.div '.first-board-continue-footer.js-continue', { tabindex: '0' }, ->
        t.p ->
          t.icon 'down'
      t.div '.first-board-continue-footer.submit-footer.is-active.hide.js-submit', { tabindex: '0' }, ->
        t.p ->
          t.format 'now-youre-a-pro-keep-building-your-board'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/create_first_board.coffee